import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Redux States
import {
  GET_COUPON_DETAIL_LIST_REQUEST,
  ADD_COUPON_DETAIL_REQUEST,
  UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
  UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_REQUEST,
  DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
} from "./actionTypes";
import {
  updateCouponDetailStatusByCouponDetailIdResponse,
  getCouponDetailListResponse,
  addCouponDetailResponse,
  updateCouponDetailByCouponDetailIdResponse,
  deleteCouponDetailByCouponDetailIdResponse,
} from "./actions";
import { invokeApi } from "helpers/axiosHelper";
import { handleApiCallException } from "store/Shared/actions";

function* getCouponDetailList() {
  try {
    const response = yield call(invokeApi, "get", "/CouponDetail", "");
    yield put(getCouponDetailListResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* addCouponDetail({ payload: { data } }) {
  try {
    const response = yield call(invokeApi, "post", "/CouponDetail", data);
    yield put(addCouponDetailResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateCouponDetailByCouponDetailId({
  payload: { couponDetailId, data },
}) {
  try {
    const response = yield call(
      invokeApi,
      "put",
      "/CouponDetail/" + couponDetailId,
      data
    );
    yield put(updateCouponDetailByCouponDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* deleteCouponDetailByCouponDetailId({ payload: { couponDetailId } }) {
  try {
    const response = yield call(
      invokeApi,
      "delete",
      "/CouponDetail/" + couponDetailId
    );
    yield put(deleteCouponDetailByCouponDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

function* updateCouponDetailStatusByCouponDetailId({
  payload: { couponDetailId, status },
}) {
  try {
    const response = yield call(
      invokeApi,
      "patch",
      "/CouponDetail/" + couponDetailId + "/" + status
    );
    yield put(updateCouponDetailStatusByCouponDetailIdResponse(response));
  } catch (error) {
    yield put(handleApiCallException(error));
  }
}

export function* watchCouponDetailMaster() {
  yield takeEvery(GET_COUPON_DETAIL_LIST_REQUEST, getCouponDetailList);
  yield takeEvery(ADD_COUPON_DETAIL_REQUEST, addCouponDetail);
  yield takeEvery(
    UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
    updateCouponDetailByCouponDetailId
  );
  yield takeEvery(
    DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST,
    deleteCouponDetailByCouponDetailId
  );
  yield takeEvery(
    UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_REQUEST,
    updateCouponDetailStatusByCouponDetailId
  );
}

function* couponDetailMasterSaga() {
  yield all([fork(watchCouponDetailMaster)]);
}

export default couponDetailMasterSaga;
